import { render, staticRenderFns } from "./TopupReviewModal.vue?vue&type=template&id=039bbe5c"
import script from "./TopupReviewModal.vue?vue&type=script&lang=js"
export * from "./TopupReviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports